var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrap},[_c('div',{class:_vm.$style.height},[_vm._v("您将分享  "+_vm._s(_vm.name))]),_c('share-base-form',{ref:"shareForm",on:{"form-validate":_vm.handeFormValidate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }